import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'

const config = {
  types: [
    {
      title: 'horizontal',
      isDefault: true
    },
    'vertical',
    'inverse',
    'icon',
    'number'
  ],
  modifiers: [
    {
      title: 'sm',
      isDefault: true
    },
    'md',
    'lg'
  ],
  states: []
}

export default function Topic(props) {
  const {
    horizontal,
    vertical,
    inverse,
    icon,
    iconSrc,
    number,
    sm,
    md,
    lg,
    fixedIcon,
    children,
    ...rest
  } = props

  const _icon = fixedIcon || icon

  return (
    <div
      {...rest}
      className={
        resolveProps(props, config, 'Topic') +
        (vertical ? ' mdn-Topic--icon' : '')
      }
    >
      <div className="mdn-Topic-symbol">
        {_icon ? <span className={`mdn-Icon-${_icon} mdn-Icon--md`} /> : null}
        {number && !fixedIcon ? number : null}
      </div>
      {typeof children === 'string'
        ? <p className="mdn-Topic-description">{children}</p>
        : <div className="mdn-Topic-description">{children}</div> }
    </div>
  )
}

Topic.propTypes = {
  horizontal: PropTypes.bool,
  vertical: PropTypes.bool,
  inverse: PropTypes.bool,
  icon: PropTypes.string,
  iconSrc: PropTypes.bool,
  number: PropTypes.number,
  sm: PropTypes.bool,
  md: PropTypes.bool,
  lg: PropTypes.bool,
  fixedIcon: PropTypes.string,
  children: PropTypes.node
}
